import ContactForm from "../../components/ContactForm";

export const ContactUs = () => {
  return (
    <div className="contact-us">
      <span className="content-padding h2">Contact us</span>
      <span className="content-padding content bottom-padding-large">
        Use this form below to get in touch with us.
      </span>

      <ContactForm />
    </div>
  );
};
